import { computed } from 'vue';
import { useMutation, useQuery } from '@tanstack/vue-query';

import http from '@/services/http';
import { queryKeys } from '@/queries/_shared/queryKeys';
import { feedEndpoints, profiClient, unwrapBody } from '@/queries/feed/client';

function normalizeArray(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

async function fetchQuizList() {
  const response = await http.get(feedEndpoints.quizList, { params: { expand: 'questions' } });
  return normalizeArray(unwrapBody(response.data));
}

async function fetchQuizDetail(id) {
  const response = await http.get(feedEndpoints.quizList, { params: { id, expand: 'questions' } });
  const list = normalizeArray(unwrapBody(response.data));
  return list[0] || null;
}

async function fetchProfiwayList() {
  const response = await profiClient.get(feedEndpoints.profiwayList, { params: { only_unfinished: true } });
  const body = unwrapBody(response.data);
  return normalizeArray(body);
}

async function startProfiwaySurvey(id) {
  const response = await profiClient.post(feedEndpoints.profiwayStart, {}, { params: { id, expand: 'survey,questions.answers,resultAnswers' } });
  return unwrapBody(response.data);
}

export function useFeedQuizListQuery() {
  return useQuery({
    queryKey: queryKeys.feed.quizList,
    queryFn: fetchQuizList
  });
}

export function useFeedQuizDetailQuery(idRef) {
  const id = computed(() => idRef?.value);
  return useQuery({
    queryKey: computed(() => queryKeys.feed.quizDetail(id.value)),
    queryFn: () => fetchQuizDetail(id.value),
    enabled: computed(() => Boolean(id.value))
  });
}

export function useFeedProfiwayListQuery() {
  return useQuery({
    queryKey: queryKeys.feed.profiwayList,
    queryFn: fetchProfiwayList
  });
}

export function useStartProfiwaySurveyMutation() {
  return useMutation({
    mutationFn: ({ id }) => startProfiwaySurvey(id)
  });
}
